import { render, staticRenderFns } from "./McToast.vue?vue&type=template&id=081475da"
import script from "./McToast.vue?vue&type=script&lang=js"
export * from "./McToast.vue?vue&type=script&lang=js"
import style0 from "./McToast.vue?vue&type=style&index=0&id=081475da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports